import { ArrowDown, Phone, ChevronRight } from 'lucide-react';
import './Hero.css';

export default function Hero() {
  return (
    <section id="hero" className="hero">

      <div className="hero__bg" />
      <div className="hero__glow hero__glow--1" />
      <div className="hero__glow hero__glow--2" />
      <div className="hero__glow hero__glow--3" />
      <div className="hero__grid" />

      <div className="container hero__content">

        <div className="hero__left">

          {/* Glass eyebrow pill */}
          <div className="hero__eyebrow">
            <span className="hero__eyebrow-dot" />
            PRISHTINA AIRPORT · RENT A CAR
          </div>

          <h1 className="hero__title">
            Makina <em className="hero__title-em">Premium</em> me Qira
          </h1>

          <p className="hero__sub">
            Flotë moderne, çmime transparente dhe
            shërbim 24/7 pa komplikime.
          </p>

          <div className="hero__actions">
            <a href="#fleet" className="hero__btn hero__btn--primary">
              Shiko Flotën
              <ChevronRight size={16} />
            </a>
            <a href="tel:+38343888408" className="hero__btn hero__btn--glass">
              <Phone size={14} />
              Na Thirr
            </a>
          </div>

        </div>

        {/* Glass stats card */}
        <div className="hero__stats-card">
          <div className="hero__stats-card-shine" />
          <div className="hero__stats">
            <div className="hero__stat">
              <strong>20+</strong>
              <span>Makina</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <strong>10+</strong>
              <span>Vite</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <strong>1000+</strong>
              <span>Klientë</span>
            </div>
            <div className="hero__stat-divider" />
            <div className="hero__stat">
              <strong>24/7</strong>
              <span>Support</span>
            </div>
          </div>
        </div>

      </div>

      <a href="#fleet" className="hero__scroll">
        <span>Scroll</span>
        <ArrowDown size={13} />
      </a>

    </section>
  );
}